import axios from 'axios';

const BASE_URL = 'https://api.alquran.cloud/v1';

// Helpers cache localStorage
const getCache = (key) => {
    try {
        const item = localStorage.getItem(key);
        if (!item) return null;
        const parsed = JSON.parse(item);
        // Vérifier expiration si elle existe
        if (parsed.expiresAt && Date.now() > parsed.expiresAt) {
            localStorage.removeItem(key);
            return null;
        }
        return parsed.data;
    } catch {
        return null;
    }
};

const setCache = (key, data, ttlMs = null) => {
    try {
        const item = { data };
        if (ttlMs) item.expiresAt = Date.now() + ttlMs;
        localStorage.setItem(key, JSON.stringify(item));
    } catch {
        // localStorage plein — on continue sans cache
    }
};

const quranApi = {
    // Get all surahs (cache permanent — les 114 sourates ne changent jamais)
    getAllSurahs: async () => {
        const cached = getCache('quran_surahs');
        if (cached) return cached;

        const response = await axios.get(`${BASE_URL}/surah`);
        const data = response.data.data;
        setCache('quran_surahs', data);
        return data;
    },

    // Get surah details with text and translation (cache permanent par sourate)
    getSurahDetails: async (surahNumber, translation = 'fr.hamidullah') => {
        const cacheKey = `quran_surah_${surahNumber}_${translation}`;
        const cached = getCache(cacheKey);
        if (cached) return cached;

        const response = await axios.get(
            `${BASE_URL}/surah/${surahNumber}/editions/quran-uthmani,${translation}`
        );
        const data = response.data.data;
        setCache(cacheKey, data);
        return data;
    },

    // Get available reciters (cache 7 jours — la liste peut évoluer rarement)
    getReciters: async () => {
        const cached = getCache('quran_reciters');
        if (cached) return cached;

        const response = await axios.get(`${BASE_URL}/edition/format/audio`);
        const data = response.data.data;
        setCache('quran_reciters', data, 7 * 24 * 60 * 60 * 1000);
        return data;
    },

    // Get audio URL for a specific ayah
    getAyahAudioUrl: (reciterId, ayahNumber) => {
        return `https://cdn.islamic.network/quran/audio/128/${reciterId}/${ayahNumber}.mp3`;
    },
};

export default quranApi;
